import {
  productEventsCategory,
  pushToEventGA4,
} from '@thg-commerce/enterprise-metrics/src/data_layer/pushToDataLayer/utils'
import { ProductBlockTitleProps } from '@thg-commerce/gravity-patterns/ProductBlock'

import { removeCurrencySymbol } from '../../../Price'

export enum EventEmitterType {
  SELECT_ITEM = 'select_item',
  SELECT_PROMOTION = 'select_promotion',
}

export function storeItemListName(productId: string, itemListName: string) {
  const sessionData = JSON.parse(
    sessionStorage.getItem('productListNames') || '{}',
  )
  sessionData[productId] = itemListName
  sessionStorage.setItem('productListNames', JSON.stringify(sessionData))
}

export function getStoredItemListName(productId: string, fallback = '') {
  const sessionData = JSON.parse(
    sessionStorage.getItem('productListNames') || '{}',
  )
  return sessionData[productId] || fallback
}

export const getGA4RecsMeta = () => {
  if (typeof window === 'undefined') return {}

  try {
    const stored = sessionStorage.getItem('ga4_recs_meta')
    return stored ? JSON.parse(stored) : {}
  } catch (err) {
    console.error('Error reading ga4_recs_meta', err)
    return {}
  }
}

export const selectedItemEvent = (
  sessionSettings,
  title,
  price,
  brand,
  sku,
  listPageTitle,
  externalIdentifier,
  useExternalIdentifier,
  useExternalIdentifierInSchema,
  defaultVariant,
  productVariant,
  index,
  content,
  widgetTabTitle,
  widgetName,
  alternateProductKeysForCategories,
  categories,
  enableEnhancedGA4EventV2,
  recsMeta,
) => {
  const itemListName = (() => {
    if (enableEnhancedGA4EventV2) {
      const storedName = getStoredItemListName(
        externalIdentifier || sku.toString(),
        widgetName,
      )
      if (storedName) return storedName
    }
    if (widgetName) {
      return widgetTabTitle ? `${widgetName} - ${widgetTabTitle}` : widgetName
    }
    if (listPageTitle) {
      return listPageTitle.replace(/.*\"([^\"]*)\"/, '$1')
    }
    return title.value
  })()

  return {
    event: 'ecom_event',
    event_name: EventEmitterType.SELECT_ITEM,
    ecommerce: {
      currencyCode: sessionSettings?.currency,
      items: [
        {
          index: index + 1 || 1,
          item_name: title?.value,
          item_id:
            (useExternalIdentifier || useExternalIdentifierInSchema) &&
            externalIdentifier
              ? externalIdentifier
              : sku.toString(),
          price: removeCurrencySymbol(price?.price?.defaultPrice),
          item_brand: brand?.name || '',
          item_list_name: itemListName,
          ...productEventsCategory(
            content || categories,
            alternateProductKeysForCategories,
          ),
          item_variant:
            defaultVariant?.externalIdentifier ||
            productVariant?.externalIdentifier ||
            '',
          page_category: recsMeta.page_category || '',
          logic_applied: recsMeta.logic_applied || '',
        },
      ],
    },
  }
}

export const selectedPapEvent = (
  sessionSettings,
  title,
  price,
  brand,
  sku,
  listPageTitle,
  externalIdentifier,
  index,
) => {
  return {
    event: 'ecom_event',
    event_name: EventEmitterType.SELECT_PROMOTION,
    promotion_name: 'Offer',
    creative_slot: 'papBanner Component',
    promotion_id: null,
    item: {
      item_id: sku.toString(),
      item_external_id: externalIdentifier
        ? externalIdentifier
        : sku.toString(),
      item_name: title?.value || '',
      item_brand: brand?.name || '',
      item_currency: sessionSettings?.currency,
      index: index?.toString() || '',
      item_page: listPageTitle || title.value,
      price: removeCurrencySymbol(price?.price?.defaultPrice) || '',
      item_promotion: 'Offer',
    },
  }
}

export const eventEmitterGA4 = (
  type,
  sessionSettings,
  title,
  price,
  brand,
  sku,
  listPageTitle,
  externalIdentifier,
  index,
  useExternalIdentifier,
  useExternalIdentifierInSchema,
  defaultVariant,
  productVariant,
  content,
  widgetTabTitle,
  widgetName,
  alternateProductKeysForCategories,
  categories,
  enableEnhancedGA4EventV2,
  recsMeta,
) => {
  pushToEventGA4(
    type === EventEmitterType.SELECT_ITEM
      ? selectedItemEvent(
          sessionSettings,
          title,
          price,
          brand,
          sku,
          listPageTitle,
          externalIdentifier,
          useExternalIdentifier,
          useExternalIdentifierInSchema,
          defaultVariant,
          productVariant,
          index,
          content,
          widgetTabTitle,
          widgetName,
          alternateProductKeysForCategories,
          categories,
          enableEnhancedGA4EventV2,
          recsMeta,
        )
      : selectedPapEvent(
          sessionSettings,
          title,
          price,
          brand,
          sku,
          listPageTitle,
          externalIdentifier,
          index,
        ),
  )
}
